import React, {Component} from 'react';

import { ReportCycleContainer, ReportStatisticContainer } from 'my-containers/report_user_2';
import { Helpers } from 'my-utils'

class ReportPage extends Component {

    componentDidMount() {
        Helpers.hideLoading();
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-4">
                    <ReportCycleContainer />
                </div>
                <div className="col-md-8">
                    <ReportStatisticContainer />
                </div>
            </div>
        );
    }
}

export default ReportPage;